<template>
  <v-badge
    overlap
    color="white"
    class="smallButtonBadge"
    bottom
    offset-x="18"
    offset-y="18"
  >
    <template v-slot:badge>
      <v-btn x-small icon slot="badge" @click="triggerFileSelection">
        <v-icon small>camera_alt</v-icon>
      </v-btn>
      <input
        class="d-none"
        type="file"
        id="file"
        ref="file"
        v-on:change="handleFileUpload"
      />
    </template>
    <v-progress-circular
      indeterminate
      color="primary"
      size="80"
      v-if="saving"
    ></v-progress-circular>
    <template v-else>
      <slot></slot>
    </template>
  </v-badge>
</template>

<script>
export default {
  name: "ImageEditBadge",
  props: {
    saveAction: {
      type: String,
      required: true
    }
  },
  data: () => ({
    saving: false
  }),
  methods: {
    handleFileUpload() {
      if (this.$refs.file.files) {
        this.saving = true;
        this.$store
          .dispatch(this.saveAction, this.$refs.file.files[0])
          .catch(() => {
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while uploading an image."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    triggerFileSelection() {
      this.$refs.file.click();
    }
  }
};
</script>
